/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import teaserImage from "../assets/img/teaser/Legalbird_Teaser_Main_500px.jpg";

import _find from "lodash/find";

// Key of list entry has to be unique and match the last part of the url of the respective page.
// Url defines (via router) which component will serve as lp template, see component Landingpage. It also serves landing page crawler list

export interface LandingPage {
  keyword: string;
  url: string;
  headline?: string;
  backgroundImage?: string;
}

export type LandingPagesList = Record<string, LandingPage>;

export const landingPagesList: LandingPagesList = {
  "internet-scheidung": {
    keyword: "Internet Scheidung",
    headline: "Internet Scheidung einfach & günstig",
    url: "/lp/internet-scheidung",
    backgroundImage: teaserImage,
  },
  "online-scheidung": {
    keyword: "Online Scheidung",
    headline: "Online Scheidung einfach & günstig",
    url: "/lp/online-scheidung",
    backgroundImage: teaserImage,
  },
  scheidungsfolgenvereinbarung: {
    keyword: "Scheidungsfolgenvereinbarung",
    headline: "Scheidungsfolgenvereinbarung",
    url: "/lp/scheidungsfolgenvereinbarung",
    backgroundImage: teaserImage,
  },
  scheidungsantrag: {
    keyword: "Scheidungsantrag",
    headline: "Scheidungsantrag einreichen",
    url: "/lp/scheidungsantrag",
    backgroundImage: teaserImage,
  },
  scheidung: {
    keyword: "Scheidung",
    headline: "Scheidung einfach & günstig",
    url: "/lp/scheidung",
    backgroundImage: teaserImage,
  },
  kuendigung: {
    keyword: "Kündigung",
    headline: "Kündigung erhalten? Jetzt Klage einreichen!",
    url: "/lp/kuendigung",
    backgroundImage: teaserImage,
  },
  abfindung: {
    keyword: "Abfindung",
    headline: "Abfindung bei Kündigung? Jetzt berechnen & klagen!",
    url: "/lp/abfindung",
    backgroundImage: teaserImage,
  },
  "bussgeld-fahrverbot": {
    keyword: "Bußgeldbescheid & Fahrverbot",
    headline: "Jetzt Einspruch einlegen!",
    url: "/lp/bussgeld-fahrverbot",
  },
  "rote-ampel": {
    keyword: "Rotlichtverstoß",
    headline: "Rote Ampel überfahren?",
    url: "/lp/rote-ampel",
  },
  verkehrsunfall: {
    keyword: "Verkehrsunfall",
    headline: "Schaden durch Verkehrsunfall erlitten?",
    url: "/lp/verkehrsunfall",
  },
  abstandsverstoss: {
    keyword: "Abstandsverstoß Bußgeld",
    headline: "Zu nah aufgefahren?",
    url: "/lp/abstandsverstoss",
  },
  geschwindigkeit: {
    keyword: "Überhöhte Geschwindigkeit Bußgeld",
    headline: "Zu schnell gefahren?",
    url: "/lp/geschwindigkeit",
  },
  "verkehr-sonstiges": {
    keyword: "Weitere Verkehrsverstöße",
    headline: "Kostenlose Ersteinschätzung bei Bußgeldbescheid!",
    url: "/lp/verkehr-sonstiges",
  },

  //partnerpages, keys not in use, keyword only for lp list
  //advocard
  "bussgeld-fahrverbot-advocard": {
    keyword: "Bußgeldbescheid & Fahrverbot Advocard",
    url: "/lp/advocard/bussgeld-fahrverbot",
  },
  "unterhalt-advocard": {
    keyword: "Unterhalt Advocard",
    url: "/lp/advocard/unterhalt",
  },
  "familienrecht-advocard": {
    keyword: "Familienrecht Advocard",
    url: "/lp/advocard/familienrecht",
  },
  "scheidung-advocard": {
    keyword: "Scheidung Advocard",
    url: "/lp/advocard/scheidung",
  },
  "todesfall-advocard": {
    keyword: "Todesfall Advocard",
    url: "/lp/advocard/todesfall",
  },
  "familienrecht-beratung-advocard": {
    keyword: "Familienrecht Beratung Advocard",
    url: "/lp/advocard/familienrecht-beratung",
  },
  "vertragsrecht-advocard": {
    keyword: "Vertragsrecht Advocard",
    url: "/lp/advocard/vertragsrecht",
  },
  "arbeitsrecht-advocard": {
    keyword: "Arbeitsrecht Advocard",
    url: "/lp/advocard/arbeitsrecht",
  },
  "zivilrecht-advocard": {
    keyword: "Zivilrecht Advocard",
    url: "/lp/advocard/zivilrecht",
  },
  "energie-hilfe-advocard": {
    keyword: "Advocard Energie Hilfe",
    url: "/lp/advocard/energie-hilfe",
  },
  "mietrecht-advocard": {
    keyword: "Advocard Mietrecht",
    url: "/lp/advocard/mietrecht",
  },
  "advocard-flexservice": {
    keyword: "FlexService",
    url: "/lp/advocard/flexservice",
  },

  //arag
  "bussgeld-fahrverbot-arag": {
    keyword: "Bußgeldbescheid & Fahrverbot Arag",
    url: "/lp/arag/bussgeld-fahrverbot",
  },
  "unterhalt-arag": {
    keyword: "Unterhalt Arag",
    url: "/lp/arag/unterhalt",
  },
  "familienrecht-arag": {
    keyword: "Familienrecht Arag",
    url: "/lp/arag/familienrecht",
  },
  "scheidung-arag": {
    keyword: "Scheidung Arag",
    url: "/lp/arag/scheidung",
  },
  "todesfall-arag": {
    keyword: "Todesfall Arag",
    url: "/lp/arag/todesfall",
  },
  "familienrecht-beratung-arag": {
    keyword: "Familienrecht Beratung Arag",
    url: "/lp/arag/familienrecht-beratung",
  },
  "kuendigung-arag": {
    keyword: "Kuendigung Arag",
    url: "/lp/arag/kuendigung",
  },

  //deurag
  "familienrecht-beratung-deurag": {
    keyword: "Familienrecht Beratung Deurag",
    url: "/lp/deurag/familienrecht-beratung",
  },

  //wbs
  "bussgeld-fahrverbot-wbs": {
    keyword: "Bußgeldbescheid & Fahrverbot WBS",
    url: "/lp/wbs/bussgeld-fahrverbot",
  },
  "kuendigung-wbs": {
    keyword: "Kündigungsschutzklage WBS",
    url: "/lp/wbs/kuendigung",
  },
  "datenweitergabe-wbs": {
    keyword: "Datenweitergabe WBS",
    url: "/lp/wbs/datenweitergabe",
  },
};

const stripTrailingSlash = (str: string): string => {
  return str.endsWith("/") ? str.slice(0, -1) : str;
};

export const getLpByLocation = (location: string) => {
  return _find(landingPagesList, ["url", stripTrailingSlash(location)]);
};
